import React, { useState, useEffect } from "react";
import SiteWrapper from "../../SiteWrapper.react";
import { Button, Form, Icon, Card } from "tabler-react";
import { Crud_Catalogos } from "../../herramientas/Crud_Catalogos";
import * as conf from "../../config/config";
import ModalLay from "../../components/ModalLay/ModalLay";
import FormFacturacion from "./FormFacturacion";
import SubirPdf from "./SubirPdf";
import CargaMasiva from "./CargaMasiva";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const ALL_COLUMNAS = [
  { key: "id_movimiento", label: "ID", minW: 70, defaultVisible: true },
  { key: "localidad", label: "Localidad", minW: 110, defaultVisible: true },
  { key: "gps_colocado", label: "GPS", minW: 90, defaultVisible: false },
  { key: "cliente", label: "Cliente", minW: 160, defaultVisible: true },
  { key: "contenedor", label: "Contenedor", minW: 140, defaultVisible: true },
  { key: "destino", label: "Destino", minW: 110, defaultVisible: false },
  { key: "transportista_corto", label: "Transportista", minW: 110, defaultVisible: false },
  { key: "fecha_colocacion", label: "Fecha Coloc.", minW: 115, defaultVisible: false },
  { key: "booking", label: "Booking", minW: 120, defaultVisible: true },
  { key: "po", label: "PO", minW: 80, defaultVisible: false },
  { key: "plataforma", label: "Plataforma", minW: 100, defaultVisible: true },
  { key: "notas", label: "Notas", minW: 110, defaultVisible: false },
  { key: "id_movimiento_full", label: "Mov Full", minW: 80, defaultVisible: false },
  { key: "gps_full", label: "GPS Full", minW: 90, defaultVisible: false },
  { key: "operacion_estatus", label: "Op. Estatus", minW: 110, defaultVisible: true },
  { key: "ruta_estatus", label: "Ruta Estatus", minW: 120, defaultVisible: true },
  { key: "sello", label: "Sello", minW: 85, defaultVisible: false },
  { key: "movimiento_tipo", label: "Tipo Mov", minW: 90, defaultVisible: false },
  { key: "service_order", label: "S.O.", minW: 75, defaultVisible: false },
  { key: "envio", label: "Envío", minW: 80, defaultVisible: true },
  { key: "estatus_facturacion", label: "Estatus Fact.", minW: 110, defaultVisible: true },
  { key: "id_sap", label: "ID SAP", minW: 85, defaultVisible: false },
  { key: "moneda", label: "Moneda", minW: 70, defaultVisible: false },
  { key: "tarifa", label: "Tarifa", minW: 80, defaultVisible: false },
  { key: "aplico_descuento", label: "Desc.", minW: 60, defaultVisible: false },
  { key: "porcentaje_descuento", label: "%", minW: 50, defaultVisible: false },
  { key: "nota_credito", label: "Nota Crédito", minW: 100, defaultVisible: false },
  { key: "imputable", label: "Imputable", minW: 95, defaultVisible: false },
  { key: "folio_factura", label: "Folio Fact.", minW: 100, defaultVisible: false },
  { key: "nota", label: "Nota Pend.", minW: 120, defaultVisible: false },
];

const STORAGE_KEY = "facturar_columnas_visibles";
const PAGE_SIZE = 50;

const getInitialColumns = () => {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) return JSON.parse(saved);
  } catch (e) {}
  return ALL_COLUMNAS.filter(c => c.defaultVisible).map(c => c.key);
};

// Componente SkeletonRow
const SkeletonRow = ({ columnas, index, skeletonStyle, tdStyle }) => (
  <tr style={{ borderBottom: "1px solid #f1f3f5" }}>
    {columnas.map(col => (
      <td key={col.key} style={tdStyle}>
        <div 
          style={{ 
            ...skeletonStyle, 
            height: "14px",
            opacity: Math.max(0.4, 1 - (index * 0.08))
          }} 
        />
      </td>
    ))}
    {/* Editar col */}
    <td style={{ ...tdStyle, textAlign: "center" }}>
      <div style={{ ...skeletonStyle, height: "30px", width: "30px", borderRadius: "50%", margin: "0 auto" }} />
    </td>
    {/* PDF col */}
    <td style={{ ...tdStyle, textAlign: "center" }}>
      <div style={{ ...skeletonStyle, height: "30px", width: "30px", borderRadius: "50%", margin: "0 auto" }} />
    </td>
  </tr>
);

const MovimientosFacturarPage = () => {
  const [fechaInicio, setFechaInicio] = useState("");
  const [fechaFin, setFechaFin] = useState("");
  const [campoFecha, setCampoFecha] = useState("cita_colocacion_gps");
  const [plataformaBusqueda, setPlataformaBusqueda] = useState("");
  const [plataformasDisponibles, setPlataformasDisponibles] = useState([]);
  const [pageData, setPageData] = useState([]);
  const [totalElements, setTotalElements] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [searchCol, setSearchCol] = useState("all");
  const [currentPage, setCurrentPage] = useState(0);
  const [hasSearched, setHasSearched] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [visibleCols, setVisibleCols] = useState(getInitialColumns);
  const [showColMenu, setShowColMenu] = useState(false);
  const [showExportModal, setShowExportModal] = useState(false);
  const [exportCols, setExportCols] = useState(() => ALL_COLUMNAS.map(c => c.key));
  const [exportEstatus, setExportEstatus] = useState("");
  const searchTimeoutRef = React.useRef(null);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(visibleCols));
  }, [visibleCols]);

  useEffect(() => {
    Crud_Catalogos("movimientos-facturar/plataformas", "plataformas", "get", "", [], "", "", "", [])
      .then((res) => { if (Array.isArray(res)) setPlataformasDisponibles(res); })
      .catch(() => {});
  }, []);

  const toggleCol = (key) => {
    setVisibleCols(prev => prev.includes(key) ? prev.filter(k => k !== key) : [...prev, key]);
  };

  // --- Exportación a Excel ---
  const toggleExportCol = (key) => {
    setExportCols(prev => prev.includes(key) ? prev.filter(k => k !== key) : [...prev, key]);
  };

  const selectAllExportCols = () => setExportCols(ALL_COLUMNAS.map(c => c.key));
  const deselectAllExportCols = () => setExportCols([]);

  const exportarExcel = (modo) => {
    if (!fechaInicio || !fechaFin) {
      alert("Debe seleccionar un rango de fechas antes de exportar.");
      return;
    }
    if (exportCols.length === 0) {
      alert("Debe seleccionar al menos una columna para exportar.");
      return;
    }

    // Pedir TODOS los datos filtrados al backend (sin paginación)
    let url = `movimientos-facturar?fechaInicio=${fechaInicio}&fechaFin=${fechaFin}&page=0&size=999999`;
    if (plataformaBusqueda) url += `&plataforma=${encodeURIComponent(plataformaBusqueda)}`;
    if (search) url += `&search=${encodeURIComponent(search)}&searchCol=${encodeURIComponent(searchCol)}`;

    setLoading(true);
    Crud_Catalogos(url, "movimientosFacturar", "get", "", [], "", "", "", [])
      .then((res) => {
        setLoading(false);
        if (res.error === true) { alert("Error al obtener datos para exportar."); return; }
        let allExportData = res.content || [];

        // Aplicar filtro de estatus si está seleccionado
        if (exportEstatus) {
          if (exportEstatus === "__sin_estatus__") {
            allExportData = allExportData.filter(r => !r.estatus_facturacion);
          } else {
            allExportData = allExportData.filter(r => r.estatus_facturacion === exportEstatus);
          }
        }

        let dataToExport;
        if (modo === "facturados") {
          dataToExport = allExportData.filter(r =>
            r.estatus_facturacion || r.moneda || r.tarifa || r.id_sap || r.folio_factura || r.nota_credito || r.envio
          );
          if (dataToExport.length === 0) { alert("No hay filas con información de facturación."); return; }
        } else if (modo === "sin_facturacion") {
          dataToExport = allExportData.filter(r =>
            !r.estatus_facturacion && !r.moneda && !r.tarifa && !r.id_sap && !r.folio_factura && !r.nota_credito && !r.envio
          );
          if (dataToExport.length === 0) { alert("No hay filas sin información de facturación."); return; }
        } else {
          dataToExport = allExportData;
        }

        if (dataToExport.length === 0) { alert("No hay datos para exportar."); return; }

        const colsToExport = ALL_COLUMNAS.filter(c => exportCols.includes(c.key));
        const headers = colsToExport.map(c => c.label);
        const rows = dataToExport.map(row =>
          colsToExport.map(col => {
            const val = row[col.key];
            if (col.key === "envio") return val ? "Enviado" : "No enviado";
            if (col.key === "aplico_descuento") return val ? "Sí" : "No";
            if (col.key === "estatus_facturacion") return val || "Pendiente";
            return val != null ? val : "";
          })
        );

        const wsData = [headers, ...rows];
        const ws = XLSX.utils.aoa_to_sheet(wsData);
        ws["!cols"] = colsToExport.map(col => ({ wch: Math.max(col.label.length + 2, 12) }));
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Movimientos");
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const blob = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        saveAs(blob, `Movimientos_Facturar_${fechaInicio}_${fechaFin}.xlsx`);
        setShowExportModal(false);
      })
      .catch(() => { setLoading(false); alert("Error al exportar."); });
  };

  const columnas = ALL_COLUMNAS.filter(c => visibleCols.includes(c.key));

  const descargarPlantilla = () => {
    fetch(conf.api_raiz + "movimientos-facturar/plantilla", {
      headers: { Authorization: "Bearer " + sessionStorage.getItem("tok") }
    }).then(res => res.blob()).then(blob => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "plantilla_facturacion.xlsx";
      document.body.appendChild(a);
      a.click();
      a.remove();
    });
  };

  const buscar = (page = 0, searchText = "", searchColumn = "all") => {
    if (!fechaInicio || !fechaFin) return;
    setLoading(true);
    setErrorMsg("");
    setHasSearched(true);
    let url = `movimientos-facturar?fechaInicio=${fechaInicio}&fechaFin=${fechaFin}&page=${page}&size=${PAGE_SIZE}`;
    if (plataformaBusqueda) url += `&plataforma=${encodeURIComponent(plataformaBusqueda)}`;
    if (searchText) url += `&search=${encodeURIComponent(searchText)}&searchCol=${encodeURIComponent(searchColumn)}`;
    Crud_Catalogos(
      url,
      "movimientosFacturar", "get", "", [], "", "", "", []
    ).then((res) => {
      if (res.error === true) {
        setErrorMsg(res.message);
        setPageData([]);
        setTotalElements(0);
        setTotalPages(1);
      } else {
        setPageData(res.content || []);
        setTotalElements(res.totalElements || 0);
        setTotalPages(res.totalPages || 1);
        setCurrentPage(page);
      }
      setLoading(false);
    }).catch(() => { setLoading(false); setErrorMsg("Error al consultar datos"); });
  };

  const changePage = (page) => {
    if (page < 0 || page >= totalPages) return;
    buscar(page, search, searchCol);
  };

  const handleSearch = (value) => {
    setSearch(value);
    // Debounce: esperar 500ms después de que deje de escribir
    if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
    searchTimeoutRef.current = setTimeout(() => {
      setCurrentPage(0);
      buscar(0, value, searchCol);
    }, 500);
  };

  const handleSearchColChange = (value) => {
    setSearchCol(value);
    if (search) {
      setCurrentPage(0);
      buscar(0, search, value);
    }
  };

  const renderCelda = (row, col) => {
    switch (col.key) {
      case "envio":
        return <span className={`badge ${row.envio ? "badge-success" : "badge-secondary"}`} style={badgeStyle}>{row.envio ? "Enviado" : "No enviado"}</span>;
      case "estatus_facturacion": {
        const cm = { "Finalizado": "badge-success", "En ruta": "badge-info", "No facturable": "badge-danger", "Alojado": "badge-primary", "Pendiente": "badge-warning", "OV": "badge-dark" };
        return <span className={`badge ${cm[row.estatus_facturacion] || "badge-secondary"}`} style={badgeStyle}>{row.estatus_facturacion || "—"}</span>;
      }
      case "aplico_descuento":
        return <span className={`badge ${row.aplico_descuento ? "badge-success" : "badge-secondary"}`} style={badgeStyle}>{row.aplico_descuento ? "Sí" : "No"}</span>;
      default:
        return row[col.key] != null ? row[col.key] : "";
    }
  };

  const badgeStyle = { fontSize: "11px", padding: "3px 8px" };

  return (
    <SiteWrapper>
      <style>{`@keyframes shimmer { 0% { background-position: -200% 0; } 100% { background-position: 200% 0; } }`}</style>
      <div style={{ padding: "1rem 1.5rem" }}>
        {/* Toolbar */}
        <Card>
          <Card.Body style={{ padding: "12px 16px" }}>
            <div style={toolbarStyle}>
              {/* Left: Dates + Search */}
              <div style={{ display: "flex", alignItems: "center", gap: "10px", flexWrap: "nowrap" }}>
                <input type="date" className="form-control" value={fechaInicio} onChange={(e) => setFechaInicio(e.target.value)} style={inputStyle} />
                <input type="date" className="form-control" value={fechaFin} onChange={(e) => setFechaFin(e.target.value)} style={inputStyle} />
                <select className="form-control" value={plataformaBusqueda} onChange={(e) => setPlataformaBusqueda(e.target.value)} style={{ ...inputStyle, width: "170px" }}>
                  <option value="">Todas las plataformas</option>
                  {plataformasDisponibles.map(p => (
                    <option key={p.nombre || p} value={p.nombre || p}>{p.nombre || p}</option>
                  ))}
                </select>
                <button className="btn btn-primary" onClick={() => { setSearch(""); buscar(0, "", "all"); }} disabled={loading} style={btnStyle}>
                  <i className="fe fe-search mr-1"></i>{loading ? "..." : "Buscar"}
                </button>
              </div>
              {/* Right: Actions */}
              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                {hasSearched && !loading && (
                  <button className="btn btn-success" onClick={() => setShowExportModal(true)} style={btnStyle}>
                    <i className="fe fe-download mr-1"></i>Excel
                  </button>
                )}
                <button className="btn btn-outline-secondary" onClick={descargarPlantilla} style={btnStyle}>
                  <i className="fe fe-file-text mr-1"></i>Plantilla
                </button>
                <span style={{ display: "inline-flex", alignItems: "center" }}>
                  <ModalLay
                    tamanio={900}
                    title="Carga Masiva de Facturación"
                    name={
                      <button className="btn btn-primary" style={btnStyle}>
                        <i className="fe fe-plus mr-1"></i>Masiva
                      </button>
                    }
                    formulario={CargaMasiva}
                    datosForm={{}}
                  />
                </span>
                {hasSearched && (
                  <div style={{ display: "flex", alignItems: "center", gap: "4px", marginLeft: "8px" }}>
                    <select
                      className="form-control"
                      value={searchCol}
                      onChange={(e) => handleSearchColChange(e.target.value)}
                      style={{ ...inputStyle, width: "140px" }}
                    >
                      <option value="all">Todas</option>
                      {ALL_COLUMNAS.map(col => <option key={col.key} value={col.key}>{col.label}</option>)}
                    </select>
                    <div style={{ position: "relative" }}>
                      <i className="fe fe-search" style={{ position: "absolute", left: "10px", top: "50%", transform: "translateY(-50%)", color: "#adb5bd", fontSize: "14px" }}></i>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Filtrar..."
                        value={search}
                        onChange={(e) => handleSearch(e.target.value)}
                        style={{ ...inputStyle, paddingLeft: "32px", width: "180px" }}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </Card.Body>
        </Card>

        {/* Error message */}
        {errorMsg && (
          <div className="alert alert-warning" style={{ marginTop: "12px" }}>
            <i className="fe fe-alert-triangle mr-2"></i>{errorMsg}
          </div>
        )}

        {/* Table */}
        {hasSearched && !errorMsg && (
          <Card style={{ marginTop: "12px" }}>
            {/* Table header bar */}
            <div style={{ padding: "10px 16px", borderBottom: "1px solid #e9ecef", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <span style={{ fontSize: "13px", color: "#495057" }}>
                {!loading && (
                  <>
                    <strong>{totalElements}</strong> resultados {search && `para "${search}"`} — Página {currentPage + 1} de {totalPages}
                  </>
                )}
                {loading && <span style={{ color: "#adb5bd" }}>Cargando datos...</span>}
              </span>
              {!loading && (
                <div style={{ position: "relative" }}>
                  <button className="btn btn-sm btn-outline-secondary" onClick={() => setShowColMenu(!showColMenu)} style={{ fontSize: "12px" }}>
                    <i className="fe fe-columns mr-1"></i>Columnas
                  </button>
                  {showColMenu && (
                    <div style={colMenuStyle}>
                      {ALL_COLUMNAS.map(col => (
                        <label key={col.key} style={{ display: "flex", alignItems: "center", gap: "6px", padding: "4px 0", cursor: "pointer", fontSize: "12px" }}>
                          <input type="checkbox" checked={visibleCols.includes(col.key)} onChange={() => toggleCol(col.key)} />
                          {col.label}
                        </label>
                      ))}
                    </div>
                  )}
                </div>
              )}
            </div>

            {/* Table content */}
            <div style={{ overflowX: "auto", padding: "0 16px 16px" }}>
              <table style={tableStyle}>
                <thead>
                  <tr>
                    {columnas.map(col => (
                      <th key={col.key} style={{ ...thStyle, minWidth: col.minW + "px" }}>{col.label}</th>
                    ))}
                    <th style={{ ...thStyle, minWidth: "50px" }}>Editar</th>
                    <th style={{ ...thStyle, minWidth: "50px" }}>PDF</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    // Skeleton rows when loading
                    [...Array(10)].map((_, i) => (
                      <SkeletonRow 
                        key={i} 
                        columnas={columnas} 
                        index={i}
                        skeletonStyle={skeletonStyle}
                        tdStyle={tdStyle}
                      />
                    ))
                  ) : (
                    // Real data rows
                    <>
                      {pageData.map((row, i) => (
                        <tr key={i} style={{ borderBottom: "1px solid #f1f3f5" }} onMouseEnter={(e) => e.currentTarget.style.background = "#f8f9fa"} onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}>
                          {columnas.map(col => (
                            <td key={col.key} style={tdStyle} title={row[col.key] != null ? String(row[col.key]) : ""}>{renderCelda(row, col)}</td>
                          ))}
                          <td style={{ ...tdStyle, textAlign: "center" }}>
                            <ModalLay
                              tamanio={700}
                              title={"Facturación - Movimiento " + row.id_movimiento}
                              name={<button className="btn btn-sm btn-outline-primary" style={actionBtnStyle}><i className="fe fe-edit-2"></i></button>}
                              formulario={FormFacturacion}
                              datosForm={{ registro: row, refrescar: () => buscar(currentPage, search, searchCol) }}
                            />
                          </td>
                          <td style={{ ...tdStyle, textAlign: "center" }}>
                            <ModalLay
                              tamanio={500}
                              title={"PDF - Movimiento " + row.id_movimiento}
                              name={<button className="btn btn-sm btn-outline-info" style={actionBtnStyle}><i className="fe fe-file-text"></i></button>}
                              formulario={SubirPdf}
                              datosForm={{ idMovimiento: row.id_movimiento }}
                            />
                          </td>
                        </tr>
                      ))}
                      {pageData.length === 0 && (
                        <tr><td colSpan={columnas.length + 2} style={{ padding: "30px", textAlign: "center", color: "#868e96" }}>
                          {search ? `No se encontraron resultados para "${search}"` : "No hay datos en el rango seleccionado"}
                        </td></tr>
                      )}
                    </>
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination - only show when not loading */}
            {!loading && (
              <div style={{ padding: "10px 16px", borderTop: "1px solid #e9ecef", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <span style={{ fontSize: "12px", color: "#868e96" }}>Mostrando {pageData.length} de {totalElements}</span>
                <div style={{ display: "flex", gap: "4px" }}>
                  <PagBtn disabled={currentPage === 0} onClick={() => changePage(0)} icon="chevrons-left" />
                  <PagBtn disabled={currentPage === 0} onClick={() => changePage(currentPage - 1)} icon="chevron-left" />
                  {[...Array(Math.min(5, totalPages))].map((_, i) => {
                    const start = Math.max(0, Math.min(currentPage - 2, totalPages - 5));
                    const p = start + i;
                    if (p >= totalPages) return null;
                    return (
                      <button key={p} className={`btn btn-sm ${p === currentPage ? "btn-primary" : "btn-outline-secondary"}`} onClick={() => changePage(p)} style={{ minWidth: "32px", height: "32px", padding: 0, fontSize: "12px" }}>
                        {p + 1}
                      </button>
                    );
                  })}
                  <PagBtn disabled={currentPage + 1 >= totalPages} onClick={() => changePage(currentPage + 1)} icon="chevron-right" />
                  <PagBtn disabled={currentPage + 1 >= totalPages} onClick={() => changePage(totalPages - 1)} icon="chevrons-right" />
                </div>
                <span style={{ fontSize: "12px", color: "#868e96" }}>Total: <strong>{totalElements}</strong></span>
              </div>
            )}
          </Card>
        )}

        {/* Modal de Exportación a Excel */}
        {showExportModal && (
          <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, background: "rgba(0,0,0,0.5)", zIndex: 9999, display: "flex", justifyContent: "center", alignItems: "center" }} onClick={() => setShowExportModal(false)}>
            <div style={{ background: "#fff", borderRadius: "10px", padding: "24px", width: "500px", maxHeight: "80vh", overflowY: "auto", boxShadow: "0 8px 32px rgba(0,0,0,0.2)" }} onClick={e => e.stopPropagation()}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
                <h4 style={{ margin: 0 }}><i className="fe fe-download mr-2"></i>Exportar a Excel</h4>
                <button className="btn btn-sm btn-outline-secondary" onClick={() => setShowExportModal(false)} style={{ border: "none", fontSize: "18px" }}>✕</button>
              </div>

              {/* Info del rango */}
              <div style={{ background: "#f1f3f5", borderRadius: "6px", padding: "10px 14px", marginBottom: "16px", fontSize: "13px" }}>
                <strong>Rango:</strong> {fechaInicio} → {fechaFin} &nbsp;|&nbsp;
                <strong>Filas:</strong> {totalElements}
              </div>

              {/* Selector de columnas */}
              <div style={{ marginBottom: "16px" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px" }}>
                  <span style={{ fontWeight: 600, fontSize: "13px" }}>Columnas a exportar:</span>
                  <div style={{ display: "flex", gap: "6px" }}>
                    <button className="btn btn-sm btn-outline-primary" onClick={selectAllExportCols} style={{ fontSize: "11px" }}>Todas</button>
                    <button className="btn btn-sm btn-outline-secondary" onClick={deselectAllExportCols} style={{ fontSize: "11px" }}>Ninguna</button>
                  </div>
                </div>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "4px 16px", maxHeight: "200px", overflowY: "auto", border: "1px solid #e9ecef", borderRadius: "6px", padding: "10px" }}>
                  {ALL_COLUMNAS.map(col => (
                    <label key={col.key} style={{ display: "flex", alignItems: "center", gap: "6px", fontSize: "12px", cursor: "pointer", padding: "2px 0" }}>
                      <input type="checkbox" checked={exportCols.includes(col.key)} onChange={() => toggleExportCol(col.key)} />
                      {col.label}
                    </label>
                  ))}
                </div>
                <span style={{ fontSize: "11px", color: "#868e96", marginTop: "4px", display: "block" }}>{exportCols.length} de {ALL_COLUMNAS.length} columnas seleccionadas</span>
              </div>

              {/* Filtro por estatus */}
              <div style={{ marginBottom: "16px" }}>
                <span style={{ fontWeight: 600, fontSize: "13px", display: "block", marginBottom: "8px" }}>Filtrar por estatus:</span>
                <select
                  className="form-control form-control-sm"
                  value={exportEstatus}
                  onChange={e => setExportEstatus(e.target.value)}
                  style={{ width: "100%" }}
                >
                  <option value="">Todos los estatus</option>
                  <option value="Alojado">Alojado</option>
                  <option value="Finalizado">Finalizado</option>
                  <option value="Pendiente">Pendiente</option>
                  <option value="En ruta">En ruta</option>
                  <option value="No facturable">No facturable</option>
                  <option value="OV">OV</option>
                  <option value="__sin_estatus__">Sin estatus asignado</option>
                </select>
              </div>

              {/* Botones de acción */}
              <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end", flexWrap: "wrap" }}>
                <button className="btn btn-info" onClick={() => exportarExcel("facturados")} style={{ fontSize: "13px" }}>
                  <i className="fe fe-file-text mr-1"></i>Con facturación
                </button>
                <button className="btn btn-warning" onClick={() => exportarExcel("sin_facturacion")} style={{ fontSize: "13px" }}>
                  <i className="fe fe-alert-circle mr-1"></i>Sin facturación
                </button>
                <button className="btn btn-success" onClick={() => exportarExcel("todos")} style={{ fontSize: "13px" }}>
                  <i className="fe fe-download mr-1"></i>Exportar{exportEstatus ? ` (${exportEstatus})` : ""}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </SiteWrapper>
  );
};

const PagBtn = ({ disabled, onClick, icon }) => (
  <button className="btn btn-sm btn-outline-secondary" disabled={disabled} onClick={onClick} style={{ width: "32px", height: "32px", padding: 0 }}>
    <i className={`fe fe-${icon}`} style={{ fontSize: "13px" }}></i>
  </button>
);

// Styles
const toolbarStyle = { display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "10px", minHeight: "44px" };
const inputStyle = { height: "36px", fontSize: "13px", width: "150px" };
const btnStyle = { height: "36px", fontSize: "13px", whiteSpace: "nowrap", display: "inline-flex", alignItems: "center" };
const tableStyle = { width: "100%", borderCollapse: "collapse", fontSize: "13px" };
const thStyle = { padding: "10px 12px", background: "#2d3748", color: "#fff", fontSize: "11px", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.4px", textAlign: "center", whiteSpace: "nowrap", position: "sticky", top: 0, zIndex: 1 };
const tdStyle = { padding: "10px 12px", verticalAlign: "middle", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" };
const actionBtnStyle = { width: "30px", height: "30px", padding: 0, borderRadius: "50%", display: "inline-flex", alignItems: "center", justifyContent: "center" };
const colMenuStyle = { position: "absolute", right: 0, top: "100%", marginTop: "4px", background: "#fff", border: "1px solid #dee2e6", borderRadius: "6px", padding: "12px 16px", zIndex: 1000, boxShadow: "0 4px 12px rgba(0,0,0,0.1)", maxHeight: "300px", overflowY: "auto", width: "200px" };
const skeletonStyle = { background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)", backgroundSize: "200% 100%", animation: "shimmer 1.5s infinite", borderRadius: "4px" };

export default MovimientosFacturarPage;